export const CareerLabel: React.FC<{isStudent: boolean}> = ({isStudent}) => (
  <div
    className={`${
      isStudent ? 'bg-category-7' : 'bg-category-3'
    } rounded-[20px]`}
  >
    <p className="text-center text-icon-sp text-white-1">
      {isStudent ? '内定者' : '社会人'}
    </p>
  </div>
);
